import React, { useEffect, useState } from "react";
import CollapsibleContainer from '../components/collapsibleContainer';
import { useSelector } from 'react-redux';

import { GoGraph } from "react-icons/go";
import texture from "../Assets/graph.jpg"

const ThreeDataPanels = ()=>{
    const settings = useSelector(state=>state.data.data)
    const [src, setSrc] = useState(null);
    const data = useSelector(state => state.data);

    useEffect(()=>{

      if (data && data.coordinates && data.planet){
        // 143

        // 89
        const x = Math.floor(data.coordinates.x * 143).toLocaleString('en-US', {minimumIntegerDigits: 3, useGrouping:false});
        const y = Math.floor((1-data.coordinates.y) * 89).toLocaleString('en-US', {minimumIntegerDigits: 3, useGrouping:false});;
        const a = data.planet == "Aqua";
        setSrc(`https://${a?"aquaexo.s3.us-east-2":"pcbexo.s3.eu-north-1"}.amazonaws.com/${a?"aquaearth_png/aquaE_ptwe_":"pcb_png/pcb_ptwe_"}${y}_${x}.png`)
        
      }
      
    }, [data])

    if (!src){
      return null;
    }

    return (
        <CollapsibleContainer open title="Electric field"  icon={<GoGraph />}>

          <img src={src} style={{width: "100%"}} />
          
        </CollapsibleContainer>
        )
}

export default ThreeDataPanels;